<template>
  <div class="add-feedback-photo">
    <div class="upload-box">
      <div class="upload-textbox">
        <div class="upload-img">
          <svg xmlns="http://www.w3.org/2000/svg" width="72" height="62" viewBox="0 0 72 62">
            <g fill="#727272">
              <path
                d="M61.17 20.033C60.538 9.233 51.635.6 40.9.6c-6.515 0-12.825 3.196-16.734 8.41-.09-.047-.184-.078-.274-.123-.238-.115-.479-.225-.726-.323-.138-.054-.276-.103-.415-.152-.243-.085-.487-.16-.738-.228-.14-.037-.277-.076-.419-.108-.269-.061-.542-.108-.82-.149-.122-.018-.242-.042-.366-.056-.396-.043-.799-.071-1.208-.071-5.954 0-10.8 4.844-10.8 10.8 0 .155.008.306.02.457C3.427 21.777 0 27.48 0 33.185 0 41.685 6.914 48.6 15.414 48.6H21.6c.662 0 1.2-.536 1.2-1.2 0-.664-.538-1.2-1.2-1.2h-6.186C8.238 46.2 2.4 40.362 2.4 33.185c0-4.985 3.246-10.16 7.718-12.304l.682-.325V19.8c0-.148.01-.299.018-.45l.01-.21-.014-.226c-.006-.104-.014-.208-.014-.314 0-4.63 3.768-8.4 8.4-8.4.37 0 .737.032 1.1.08.094.012.186.028.279.044.321.052.638.122.95.212.041.012.083.02.123.031.343.105.678.238 1.005.387.083.037.165.078.246.118.29.143.575.302.849.48C26.064 13.05 27.6 15.646 27.6 18.6c0 .664.538 1.2 1.2 1.2.662 0 1.2-.536 1.2-1.2 0-3.305-1.495-6.263-3.84-8.245C29.6 5.855 35.266 3 40.9 3c9.294 0 17.014 7.362 17.818 16.664-1.226-.086-3.063-.13-4.9.15-.654.1-1.104.712-1.005 1.367.09.594.601 1.02 1.185 1.02.06 0 .12-.005.182-.014 2.669-.403 5.452-.025 5.62-.003 5.588 1.062 9.8 6.21 9.8 11.982 0 6.635-5.399 12.034-12.034 12.034H52.8c-.662 0-1.2.536-1.2 1.2 0 .664.538 1.2 1.2 1.2h4.766C65.525 48.6 72 42.125 72 34.166c0-6.586-4.592-12.494-10.83-14.133z"
              />
              <path
                d="M38.05 32.153c-.11-.112-.244-.2-.392-.26-.292-.122-.624-.122-.916 0-.148.06-.28.148-.392.26l-9.598 9.599c-.47.469-.47 1.227 0 1.696.234.234.54.352.848.352.307 0 .614-.118.848-.352L36 35.897V60.6c0 .664.538 1.2 1.2 1.2.662 0 1.2-.536 1.2-1.2V35.897l7.552 7.551c.234.234.54.352.848.352.307 0 .614-.118.848-.352.47-.469.47-1.227 0-1.696l-9.598-9.6z"
              />
            </g>
          </svg>
        </div>
        <h2>{{$t('uploadAPhotoOrVideo')}}</h2>
      </div>
      <input type="file" class="upload_input" @change="uploadPhoto" multiple />
      <span class="upload-msg">{{$t('supportFormat')}} JPG, PNG, GIF, MP3/4</span>
    </div>
    <div class="upload-thumb">
      <div class="show-item" v-for="(image,index) in feedbackImagePreview" :key="index">
      <span class="item-name">{{image}}</span>
        <!-- <video :src="image" v-if="image && image.includes('data:video')" :alt="image" />
        <img :src="image" v-if="image && image.includes('data:image/')" :alt="image" />
        <img src="../assets/images/doc.png" alt v-else /> -->
        <span class="icon-Btn close-icon" @click="cutPic(index)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path
              fill="#ccc"
              d="M11.952 2.048c-2.73-2.73-7.173-2.73-9.904 0-2.73 2.73-2.73 7.173 0 9.904 2.73 2.73 7.173 2.73 9.904 0 2.73-2.73 2.73-7.174 0-9.904zm-2.19 7.714c-.21.21-.552.21-.762 0l-2-2-2.095 2.095c-.21.21-.551.21-.762 0-.21-.21-.21-.552 0-.762L6.238 7l-2-2c-.21-.21-.21-.552 0-.762.21-.21.552-.21.762 0l2 2 1.905-1.904c.21-.21.551-.21.761 0 .21.21.21.551 0 .761L7.762 7l2 2c.21.21.21.551 0 .762z"
            />
          </svg>
        </span>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import constant from "../utils/constant";
import { getBase64Url } from "../utils/helper";

export default {
  props: {
    previousImages: {
      type: Array
    }
  },

  data() {
    return {
      uploadShopPhoto: "Click Pic or upload",
      loading: false,
      imagePreview: [],
      feedbackFile: "",
      feedbackImagePreview: [],
      docType: 0
    };
  },
  watch: {
    previousImages(val) {
      this.imagePreview = this.previousImages;
      if (!this.feedbackImagePreview.length) {
        this.feedbackImagePreview = [...this.feedbackImagePreview, ...val];
      }
    }
  },

  methods: {
    cutPic(id) {
      this.feedbackImagePreview.splice(id, 1);
      this.imagePreview.splice(id, 1);
      this.$emit("uploadImageList", this.imagePreview);
    },

    async uploadPhoto(file) {
      console.log(file)
      const image = file.target.files[0];
      console.log(image)
      this.feedbackImagePreview.push(image.name);
      // getBase64Url(image).then(data => {
      //   console.log(data)
      //   this.feedbackImagePreview.push(data);
      // });
      const formData = new FormData();
      this.loading = true;
      formData.append("image", image, image.name);
      formData.append("isResizeRequired", true);
      await axios
        .post(constant.FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          console.log(data.data)
          this.feedbackFile = data.data.mediaVariantDTOs[0].url;
          this.loading = false;
          if((data.data.mediaVariantDTOs[0].url).includes('.mp4')){
            this.docType = 0
          } else if((data.data.mediaVariantDTOs[0].url).includes(('.txt'))){
            this.docType = 1
          } else if((data.data.mediaVariantDTOs[0].url).includes(('.pdf'))){
            this.docType = 2
          } else if((data.data.mediaVariantDTOs[0].url).includes(('.jpg'))){
            this.docType = 3
          }else if((data.data.mediaVariantDTOs[0].url).includes(('.docs'))){
            this.docType = 4
          }else if((data.data.mediaVariantDTOs[0].url).includes(('.doc'))){
            this.docType = 5
          }else if((data.data.mediaVariantDTOs[0].url).includes(('.xml'))){
            this.docType = 6
          }else if((data.data.mediaVariantDTOs[0].url).includes(('.xml'))){
            this.docType = 7
          }else{
            this.docType = 8
          }
          this.feedbackFile = {            
            // doc_type : this.docType,
            document : data.data.mediaVariantDTOs[0].url
          }
          this.imagePreview.push(this.feedbackFile);
          this.$emit("uploadImageList", this.imagePreview);
        })
        .catch(err => {
          this.loading = false
          console.log("FAILURE", err);
        });
    }
  }
};
</script>

<style>
.loader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #e5dcdc36;
  z-index: 9;
}
.loader p {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -45%);
  font-weight: 600;
  padding: 5px;
  background: #000000bd;
  color: #fff;
  border-radius: 10px;
}
.uploadFile {
  border-radius: 8px;
  border: 1px dashed #dddddd;
  background-color: #f4f6f8;
  padding: 8px 15px;
  text-align: center;
}
.uploadFile label {
  color: #505050;
  font-size: 0.875em;
  line-height: 1.5;
}
.uploadFile svg {
  display: block;
  margin: 0 auto 8px;
}
.uploadFile input[type="file"] {
  display: none;
}
.upload_photo {
  display: block;
  border: 1px solid green;
  width: fit-content;
  padding: 8px 25px;
  border-radius: 5px;
  color: green;
  margin: 8px auto 0;
}
.image-preview {
  width: 100%;
}
.image-preview ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.image-preview li {
  width: 20%;
  line-height: 0;
  text-align: center;
  height: 65px;
  border: 1px solid #bfbdbd;
  margin: 10px 15px 20px 0;
  background: #dddddd;
}
.image-preview li:nth-child(4n + 0) {
  margin-right: 0;
}
.image-preview li img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-bottom: 4px;
}
</style>
